import React, { useState, useEffect, useRef } from 'react';
import { Box, Grid, Typography, Dialog, Button, Hidden, useTheme, useMediaQuery, Modal } from '@mui/material';
import Images from '../../utils/Images';
import { useDispatch, useSelector } from 'react-redux';
import { fetchProducts } from '../../store/Products/productsSlice';
import axios from 'axios';
import { API } from '../../utils/Api';
import StoreHeader from '../../components/StoreHeader';
import toast from 'react-hot-toast';
import { useNavigate, useParams } from 'react-router-dom';
import { setData } from '../../store/Cart/cartSlice';
import ArrivingNowOrders from '../../components/ArrivingNowOrders';
import ProductListingSkeleton from '../../components/SkeletonComponents/ProductListingSkeleton';
import AuthModals from '../../components/AuthComponents/AuthModals';
import ProductDrawer from '../../components/ProductDrawer';
import { Player } from '@lottiefiles/react-lottie-player';
import SortByComponent from '../../components/SortByComponent';
import ProductCard from '../../components/ProductCard';
import { useSocket } from '../../context/SocketContext';
import { Helmet } from 'react-helmet-async';
import FloatingCart from '../../components/FloatingCart';
import { setSearchText } from '../../store/Search/SearchSlice';
import BirthdayModal from '../../components/BirthdayModal';

const ProductsListing = () => {
  const [showBox, setShowBox] = useState(false);
  const [loginModalOpen, setLoginModalOpen] = useState(false);
  const dispatch = useDispatch();
  const socket = useSocket();
  const [products, setProducts] = useState([]);
  const [categories, setCategories] = useState([]);
  const NEW_ARRIVALS_ID = 'NEW_ARRIVALS';
  const [activeCategory, setActiveCategory] = useState(null);
  // const [activeCategory, setActiveCategory] = useState(NEW_ARRIVALS_ID);
  // const [activeCategory, setActiveCategory] = useState(categories[0]?._id);
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [fetchingProductDetails, setFetchingProductDetails] = useState(false);
  const productDetailsRequestRef = useRef(0);
  const outlet = localStorage.getItem("selectedStoreData");
  const deliveryType = localStorage.getItem("selectedOrderType");
  const ordersType = localStorage.getItem("selectedOrderType");
  const token = localStorage.getItem("token");
  const outletObject = JSON.parse(outlet);
  const outletId = outletObject?._id;
  const [isFavorited, setIsFavorited] = useState(false);
  const [quantity, setQuantity] = useState(1);
  const [cartData, setCartData] = useState([]);
  const navigate = useNavigate();
  const cartDataRedux = useSelector(state => state?.cart?.data);
  const searchText = useSelector(state => state?.search?.searchText);
  const [outletData, setOutletData] = useState(JSON.parse(localStorage.getItem('selectedStoreData')));
  const [isDataAvailable, setIsDataAvailable] = useState(false);
  const theme = useTheme();
  const matchesMdUp = useMediaQuery(theme.breakpoints.up('md'));
  const [selectedAddons, setSelectedAddons] = useState({});
  const [addingToCart, setAddingToCart] = useState(false);
  const [fetchingProducts, setFetchingProducts] = useState(true);
  const matchesMobile = useMediaQuery(theme.breakpoints.up('md'));
  const [bestCoupon, setBestCoupon] = useState({ product: [], category: [], universal: [] });
  const [activeFilter, setActiveFilter] = useState(null);
  const [popAdvertisement, setPopAdvertisement] = useState(false);
  const [randomAd, setRandomAd] = useState([]);
  const [gettingBestCoupons, setGettingBestCoupons] = useState(true);
  const [newArrivals, setNewArrivals] = useState([]);
  const containerRef = useRef(null);
  const [isModalOpen, setModalOpen] = useState(false);
  const [birthdayModal, setBirthdayModal] = useState(false);

  const sectionRefs = useRef({}); // { [id]: HTMLElement }
  const setSectionRef = (id) => (el) => {
    if (el) sectionRefs.current[id] = el;
  };

  const scrollToSection = (id) => {
    const el = sectionRefs.current[id];
    if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
  };

  const fetchUserData = async () => {
    try {
      const response = await axios.get(`${API.BASE_URL_2}user/profile`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      const user = response.data?.data?.user;
      const dob = user?.dob;
      const orderCount = user?.ordersCount;

      const lastDismissed = localStorage.getItem('lastBirthdayModalDismissed');
      const now = Date.now();
      const oneWeek = 7 * 24 * 60 * 60 * 1000;
      // const oneWeek = 11000;

      if (!dob && orderCount >= 3) {
        if (!lastDismissed || now - Number(lastDismissed) > oneWeek) {
          setBirthdayModal(true);
        }
      } else {
        setBirthdayModal(false);
      }

    } catch (error) {
      console.log("Fetch profile error:", error);
    }
  };

  const getPopupAdvertisment = async () => {
    if (!outletData?._id || !deliveryType) {
      return null;
    }
    try {
      const response = await axios.get(`${API.BASE_URL}in-app-advertisement/getRandomAd/new?outletId=${outletId}&ordersType=${ordersType}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      const advertisement = response?.data?.data?.advertisement;
      setRandomAd(advertisement);
      return advertisement;
    } catch (error) {
      console.log('Random Ads Error', error?.response?.data);
      return null;
    }
  };

  useEffect(() => {
    if (!token || !outletData?._id || !deliveryType) {
      return;
    }

    const delay = 15000;
    const oneHour = 1 * 60 * 60 * 1000;

    // const delay = 1000;
    // const oneHour = 1000;

    const timer = setTimeout(async () => {
      const lastPopup = localStorage.getItem('lastPopupTimestamp');
      const now = Date.now();

      // Wait for birthdayModal to be resolved before showing ad
      if (!birthdayModal && (!lastPopup || now - Number(lastPopup) > oneHour)) {
        const advertisement = await getPopupAdvertisment();
        if (advertisement) {
          setPopAdvertisement(true);
          localStorage.setItem('lastPopupTimestamp', now);
        }
      }
    }, delay);

    return () => clearTimeout(timer);
  }, [birthdayModal]);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  // const handleCategoryClick = (categoryId, index) => {
  //   setActiveCategory(categoryId);
  //   dispatch(fetchProducts(categoryId));
  //   console.log("Products after dispatching fetchProducts:", products);
  //   scrollToIndex(index);
  // };

  const handleCategoryClick = (categoryId) => {
    setActiveCategory(categoryId);

    if (categoryId === NEW_ARRIVALS_ID) {
      scrollToSection(NEW_ARRIVALS_ID);
      return;
    }

    scrollToSection(categoryId);
  };

  useEffect(() => {
    fetchUserCartData();
    const shimmerTimeout = setTimeout(() => {
      setShowBox(true);
    }, 3000);
    return () => clearTimeout(shimmerTimeout);
  }, []);

  const handleProductClick = (product) => {
    setSelectedProduct(product);
    setQuantity(1);
    setSelectedAddons({});
    getProductData(product?._id);
  };

  const handleAdvertismentProductClick = (randomAd) => {
    const isMdDown = window.innerWidth < 600;
    if (!randomAd?.isSubscriptionAd) {
      const product = randomAd?.product;
      setSelectedProduct(product);
      setQuantity(1);
      setSelectedAddons({});
      getProductData(product?._id);
    } else {
      if (isMdDown) {
        navigate('/subscriptions');
      }
    }
    setPopAdvertisement(false);
  };

  const handleCloseModal = () => {
    productDetailsRequestRef.current += 1;
    setSelectedProduct(null);
    setQuantity(1);
    setSelectedAddons({});
    setFetchingProductDetails(false);
  };

  const handleIncreaseQuantity = () => {
    setQuantity((prevQuantity) => prevQuantity + 1);
  };

  const handleDecreaseQuantity = () => {
    if (quantity > 1) {
      setQuantity((prevQuantity) => prevQuantity - 1);
    }
  };

  // useEffect(() => {
  //   if (selectedProduct?.hasAddon && selectedProduct?.addons && selectedProduct?.addons?.length > 0) {
  //     const defaultAddons = {};
  //     selectedProduct?.addons?.forEach((addon) => {
  //       const defaultAddonValue = addon?.addonValues?.find((value) => value?.isDefault);
  //       if (defaultAddonValue) {
  //         defaultAddons[addon._id] = defaultAddonValue;
  //       }
  //     });
  //     setSelectedAddons(defaultAddons);
  //   }
  // }, [selectedProduct]);

  const handleAddonSelect = (addonId, addonValue, isMultipleSelect = false) => {
    setSelectedAddons((prevSelectedAddons) => {
      if (isMultipleSelect) {
        const currentSelections = Array.isArray(prevSelectedAddons[addonId]) ? prevSelectedAddons[addonId] : [];
        const isAlreadySelected = currentSelections.some(
          (selected) => selected._id === addonValue._id
        );
        const updatedSelections = isAlreadySelected
          ? currentSelections.filter((selected) => selected._id !== addonValue._id) : [...currentSelections, addonValue];
        // console.log('updatedSelections', updatedSelections);
        return {
          ...prevSelectedAddons,
          [addonId]: updatedSelections,
        };
      } else {
        const isSelected = prevSelectedAddons[addonId]?._id === addonValue?._id;
        const isDefault = addonValue?.isDefault;
        if (isSelected && !isDefault) {
          const updatedAddons = { ...prevSelectedAddons };
          delete updatedAddons[addonId];
          return updatedAddons;
        }
        return {
          ...prevSelectedAddons,
          [addonId]: addonValue,
        };
      }
    });
  };

  useEffect(() => {
    if (!selectedProduct?.hasAddon || !selectedProduct?.addons?.length) {
      setSelectedAddons({});
      return;
    }

    const initial = {};
    selectedProduct?.addons?.forEach((addon) => {
      // find all valid defaults
      const defaults = (addon?.values || [])
        .filter(v =>
          v?.isDefault &&
          v?.status !== 'INACTIVE' &&
          !v?.excludedOutlets?.includes(outletData._id)
        );

      if (defaults?.length) {
        if (addon?.isMultipleSelect) {
          initial[addon?._id] = defaults.map(v => ({
            ...v,
            offerPrice: v?.price ?? 0,
            mrp: v?.price ?? 0,
          }));
        } else {
          const v = defaults[0];
          initial[addon?._id] = {
            ...v,
            offerPrice: v?.price ?? 0,
            mrp: v?.price ?? 0,
          };
        }
      }
    });

    setSelectedAddons(initial);
  }, [selectedProduct, outletData]);

  const handleAddToCart = async () => {
    if (token) {
      setAddingToCart(true);
      try {
        const addonsArray = Object.keys(selectedAddons).map((addonId) => {
          const selectedAddon = selectedAddons[addonId];
          if (Array.isArray(selectedAddon)) {
            return selectedAddon.map((addonValue) => ({
              _id: addonId,
              selectedValue: addonValue?.value,
              addonValueId: addonValue?._id,
            }));
          } else {
            return {
              _id: addonId,
              selectedValue: selectedAddon.value,
              addonValueId: selectedAddon._id,
            };
          }
        });
        // Flatten the addonsArray to ensure a single array of objects
        const flattenedAddonsArray = addonsArray.flat();
        const cartItem = {
          ordersType: deliveryType,
          outlet: outletId,
          cartItems: [
            {
              product: selectedProduct._id,
              quantity: quantity,
              sourceType: "WEBSITE",
              addons: flattenedAddonsArray.length > 0 ? flattenedAddonsArray : undefined,
            }
          ],
        };
        const response = await axios.post(`${API.BASE_URL_2}cart/new`, cartItem, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });
        handleCloseModal();
        fetchUserCartData();
        setAddingToCart(false);
        toast.success('Product added to cart!!!');
        console.log(response.data);
      } catch (error) {
        console.error(error);
      } finally {
        setAddingToCart(false);
      }
    } else {
      if (matchesMdUp) {
        handleOpenAuth();
      } else {
        navigate('/mobileNumber');
      }
    }
  };

  const fetchUserCartData = async () => {
    if (!token || !outletData?._id) {
      return;
    }
    try {
      const response = await axios.get(`${API.BASE_URL_2}cart/userCart/new/${outletData._id}/${deliveryType}?source=WEBSITE`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      dispatch(setData(response?.data));
      setCartData(cartDataRedux);
      // console.log('cartDataRedux', cartDataRedux);
      // console.log('Cart Screen Data', response?.data?.data?.cartItems);
    } catch (error) {
      dispatch(setData([]));
      console.log('Cart Screen Error', error?.response?.data);
    }
  };

  // const getCategoriesList = async () => {
  //   setFetchingProducts(true);
  //   if (!outletData?._id) {
  //     return;
  //   }
  //   try {
  //     const response = await axios.get(`${API.BASE_URL}masters/category/getCategoryWithProducts/${outletData._id}`, {
  //       headers: token
  //         ? {
  //           Authorization: `Bearer ${token}`,
  //         }
  //         : {},
  //       params: {
  //         search: searchText,
  //         foodType: activeFilter
  //       }
  //     });
  //     let fetchedCategories = response?.data?.data?.categories;

  //     // Sort categories if isEventOutlet is true
  //     if (outletData?.isEventOutlet) {
  //       fetchedCategories = fetchedCategories.sort((a, b) => {
  //         return (b.isEventCategory ? 1 : 0) - (a.isEventCategory ? 1 : 0);
  //       });
  //     }
  //     setCategories(response?.data?.data?.categories);
  //     setFetchingProducts(false);
  //     // console.log('Outlet data', outletData.isEventOutlet);
  //     // setProducts(response.data.data.products);
  //     // console.log('Categories fetched successfully in the screen:', response?.data?.data?.categories);
  //   } catch (error) {
  //     console.error('Error:', error);
  //   } finally {
  //     setFetchingProducts(false);
  //   }
  // };

  // useEffect(() => {
  //   const handleVisibilityChange = () => {
  //     if (document.visibilityState === 'visible') {
  //       getCategoriesList();
  //     }
  //   };
  //   document.addEventListener('visibilitychange', handleVisibilityChange);
  //   return () => {
  //     document.removeEventListener('visibilitychange', handleVisibilityChange);
  //   };
  // }, []);

  useEffect(() => {
    getCategoriesList();
  }, [searchText, activeFilter]);

  useEffect(() => {
    fetchUserCartData();
    // getCategoriesList();
    // getProductsList(activeCategory);
  }, []);

  const getProductQuantityInCart = (productId) => {
    let totalQuantity = 0;
    cartDataRedux?.data?.cartItems?.forEach(item => { if (item.product._id === productId) { totalQuantity += item.quantity; } });
    return totalQuantity;
  };

  const scrollToIndex = (index) => {
    const container = containerRef.current;
    const element = container.childNodes[index];
    if (element) {
      element.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  const [totalPrice, setTotalPrice] = useState(selectedProduct?.newOfferPrice || 0);
  const [totalMrpPrice, setTotalMrpPrice] = useState(selectedProduct?.newMrp || 0);
  const [offerPercentage, setOfferPercentage] = useState(0);

  useEffect(() => {
    const calculateTotalPrice = () => {
      let price = selectedProduct?.newOfferPrice ?? 0;
      let mrp = selectedProduct?.newMrp ?? 0;

      Object.values(selectedAddons).forEach(addon => {
        if (Array.isArray(addon)) {
          addon.forEach(val => {
            price += val?.offerPrice ?? val?.price ?? 0;
            mrp += val?.mrp ?? val?.price ?? 0;
          });
        } else if (addon && typeof addon === 'object') {
          price += addon?.offerPrice ?? addon?.price ?? 0;
          mrp += addon?.mrp ?? addon?.price ?? 0;
        }
      });

      setTotalPrice(price);
      setTotalMrpPrice(mrp);
    };

    calculateTotalPrice();
  }, [selectedAddons, selectedProduct]);

  useEffect(() => {
    if (totalMrpPrice > 0 && totalPrice < totalMrpPrice) {
      const discount = ((totalMrpPrice - totalPrice) / totalMrpPrice) * 100;
      setOfferPercentage(discount);
    } else {
      setOfferPercentage(0);
    }
  }, [totalPrice, totalMrpPrice]);

  const params = useParams();
  const referralId = params['referId'];

  useEffect(() => {
    if (referralId) {
      localStorage.setItem('referralId', referralId);
      // console.log("Referral ID stored in localStorage:", referralId);
    }
  }, [referralId]);

  const handleOpenAuth = () => {
    setModalOpen(true);
  }

  const handleCloseAuth = () => {
    setModalOpen(false);
  }

  const handleCloseBirthday = () => {
    const now = Date.now();
    localStorage.setItem('lastBirthdayModalDismissed', now);
    setBirthdayModal(false);
  }

  const handleFilterChange = (value) => {
    setActiveFilter(value);
  };

  const categoriesCacheRef = useRef({ query: null, data: null });

  // const getCategoriesList = async () => {
  //   if (!outletData?._id) return;
  //   const cacheKey = `categoriesCache_${outletData._id}_${searchText}_${activeFilter || 'all'}`;

  //   // Try to retrieve cached data from sessionStorage
  //   const cachedItem = sessionStorage.getItem(cacheKey);
  //   if (cachedItem) {
  //     try {
  //       const parsedCache = JSON.parse(cachedItem);
  //       setCategories(parsedCache);
  //       setFetchingProducts(false);
  //       console.log("Using cached categories from sessionStorage");
  //       return;
  //     } catch (error) {
  //       console.error("Error parsing cached data:", error);
  //     }
  //   }

  //   setFetchingProducts(true);
  //   try {
  //     const response = await axios.get(
  //       // `${API.BASE_URL}masters/category/getCategoryWithProducts/${outletData._id}`,
  //       `${API.BASE_URL}product/getProductsWithAddons?outletId=${outletData._id}`,
  //       {
  //         headers: token ? { Authorization: `Bearer ${token}` } : {},
  //         params: {
  //           search: searchText,
  //           foodType: activeFilter
  //         }
  //       }
  //     );
  //     let fetchedCategories = response?.data?.data?.categories;
  //     if (outletData?.isEventOutlet) {
  //       fetchedCategories = fetchedCategories.sort((a, b) => {
  //         return (b.isEventCategory ? 1 : 0) - (a.isEventCategory ? 1 : 0);
  //       });
  //     }
  //     setCategories(fetchedCategories);
  //     // Store the fetched data in sessionStorage (only for the current session)
  //     sessionStorage.setItem(cacheKey, JSON.stringify(fetchedCategories));
  //   } catch (error) {
  //     console.error('Error:', error);
  //   } finally {
  //     setFetchingProducts(false);
  //   }
  // };

  const getCategoriesList = async () => {
    if (!outletData?._id) return;
    setFetchingProducts(true);
    try {
      const response = await axios.get(
        // `${API.BASE_URL}masters/category/getCategoryWithProducts/${outletData._id}`,
        `${API.BASE_URL}product/getProductsWithAddonsV4?outletId=${outletData._id}&orderType=${ordersType}`,
        {
          headers: token ? { Authorization: `Bearer ${token}` } : {},
          params: {
            search: searchText,
            foodType: activeFilter
          }
        }
      );
      let fetchedCategories = response?.data?.data?.categories;
      if (outletData?.isEventOutlet) {
        fetchedCategories = fetchedCategories.sort((a, b) => {
          return (b.isEventCategory ? 1 : 0) - (a.isEventCategory ? 1 : 0);
        });
      }
      setCategories(fetchedCategories);
    } catch (error) {
      console.error('Error:', error);
    } finally {
      setFetchingProducts(false);
    }
  };

  const getProductData = async (productId) => {
    if (!productId || !outletData?._id) return;
    const requestId = ++productDetailsRequestRef.current;
    setFetchingProductDetails(true);
    try {
      const response = await axios.get(
        `${API.BASE_URL}product/get-product-category-addon-details/${productId}/${outletData._id}/${ordersType}`,
        {
          headers: token ? { Authorization: `Bearer ${token}` } : {},
        }
      );
      if (requestId !== productDetailsRequestRef.current) return;
      const productDetails = response?.data?.data?.product;
      if (productDetails) {
        setSelectedProduct({
          ...productDetails,
          isExhausted: productDetails?.isExhausted ?? productDetails?.exhausted ?? false,
        });
      }
    } catch (error) {
      console.error('Error:', error);
    } finally {
      if (requestId === productDetailsRequestRef.current) {
        setFetchingProductDetails(false);
      }
    }
  };

  // const getNewArrivalsList = async () => {
  //   if (!outletData?._id) return;
  //   setFetchingProducts(true);
  //   try {
  //     const response = await axios.get(
  //       `${API.BASE_URL}outlet-wise-new-arrivals?outlet=${outletData._id}&orderType=${ordersType}`,
  //       {
  //         headers: token ? { Authorization: `Bearer ${token}` } : {},
  //       }
  //     );
  //     setNewArrivals(response?.data?.data?.outletWiseNewArrivals);
  //     // console.log('Logggg', response?.data?.data?.outletWiseNewArrivals);
  //   } catch (error) {
  //     console.error('Error:', error);
  //   } finally {
  //     setFetchingProducts(false);
  //   }
  // };

  const getBestCoupons = async () => {
    if (!outletData?._id) return;
    setGettingBestCoupons(true);
    try {
      const response = await axios.get(
        `${API.BASE_URL}coupons/user-best-coupon/${outletData._id}&ordersType=${ordersType}`,
        {
          headers: token ? { Authorization: `Bearer ${token}` } : {},
        }
      );
      const data = response?.data?.data?.dbResponse || {};
      setBestCoupon({
        product: data?.productCoupons || [],
        category: data?.categoryCoupons || [],
        universal: data?.universalCoupons || [],
      });
      // console.log('best coupon', response?.data?.data);
      setGettingBestCoupons(false);
    } catch (error) {
      console.error('Error:', error);
      setGettingBestCoupons(false);
    } finally {
      setGettingBestCoupons(false);
    }
  };

  const getBestCouponForProduct = (product, categoryId) => {
    const productCoupon = bestCoupon?.product?.find(coupon => coupon?.productId === product?._id);
    if (productCoupon) return productCoupon;

    const categoryCoupon = bestCoupon?.category?.find(coupon => coupon?.categoryId === categoryId);
    if (categoryCoupon) return categoryCoupon;

    return bestCoupon?.universal?.length > 0 ? bestCoupon?.universal[0] : null;
  };

  // // This function is similar but is triggered by socket events to force update
  // const getCategoriesListSocket = async () => {
  //   if (!outletData?._id) return;
  //   const cacheKey = `categoriesCache_${outletData._id}_${searchText}_${activeFilter || 'all'}`;

  //   try {
  //     // const response = await axios.get(`${API.BASE_URL}masters/category/getCategoryWithProducts/${outletData._id}`, {
  //     const response = await axios.get(`${API.BASE_URL}product/getProductsWithAddons?outletId=${outletData._id}`, {
  //       headers: token ? { Authorization: `Bearer ${token}` } : {},
  //     });
  //     let fetchedCategories = response?.data?.data?.categories;
  //     if (outletData?.isEventOutlet) {
  //       fetchedCategories = fetchedCategories.sort((a, b) => {
  //         return (b.isEventCategory ? 1 : 0) - (a.isEventCategory ? 1 : 0);
  //       });
  //     }
  //     setCategories(fetchedCategories);
  //     categoriesCacheRef.current = { query: JSON.stringify({ searchText, activeFilter, outletId: outletData._id }), data: fetchedCategories };
  //     sessionStorage.setItem(cacheKey, JSON.stringify(fetchedCategories));
  //   } catch (error) {
  //     console.error('Error:', error);
  //   }
  // };

  // Instead of calling getCategoriesList repeatedly, call it only when needed.
  useEffect(() => {
    let timeoutId;
    const checkDataAvailability = () => {
      if (outletData) {
        setIsDataAvailable(true);
        clearTimeout(timeoutId);
        getCategoriesList();
      } else {
        timeoutId = setTimeout(checkDataAvailability, 500);
        setOutletData(JSON.parse(localStorage.getItem('selectedStoreData')));
      }
    };
    checkDataAvailability();
    return () => clearTimeout(timeoutId);
  }, [outletData]);

  useEffect(() => {
    if (!socket || !outletId) return;
    console.log('Connected to socket server');

    const events = [
      { name: 'newProductAdded', message: 'New Product Added' },
      { name: 'productUpdated', message: 'Product Updated' },
      { name: 'productDeleted', message: 'Product Deleted' },
      { name: 'productOutOfStock', message: 'Product Out Of Stock' },
      { name: 'productRestocked', message: 'Product Restocked' },
      { name: 'newCategoryAdded', message: 'New Category Added' },
      { name: 'categoryUpdated', message: 'Category Updated' },
      { name: 'categoryDeleted', message: 'Category Deleted' },
      { name: 'categoryDisplayImageUpdated', message: 'Category Display Image Updated' },
      { name: 'newCouponAdd', message: 'New Coupon Added' },
      { name: 'couponUpdate', message: 'Coupon Updated' },
      { name: 'couponDelete', message: 'Coupon Deleted' },
      { name: 'productAddonAdd', message: 'Product addon added' },
      { name: 'productAddonUpdate', message: 'Product addon updated' },
      { name: 'productAddonDelete', message: 'Product addon deleted', },
      { name: 'productAddonItemAdd', message: 'Product Addon item added' },
      { name: 'productAddonItemDelete', message: 'Product addon item deleted' },
      { name: 'productAddonIconAdd', message: 'Product addon Icon added' }
    ];

    // events.forEach(({ name, message }) => {
    //   socket.on(name, () => {
    //     setTimeout(getCategoriesListSocket, 1000);
    //     console.log(message);
    //   });
    // });

    return () => {
      events.forEach(({ name }) => socket.off(name));
    };
  }, [socket, outletId]);
  // }, [socket, outletId, getCategoriesListSocket]);

  useEffect(() => {
    // getCategoriesListSocket();
    getBestCoupons();
  }, [token]);

  useEffect(() => {
    const hasNewArrivals = (newArrivals?.length ?? 0) > 0;
    const firstCategoryId = categories?.[0]?._id;

    if (hasNewArrivals) {
      // ✅ Always prefer New Arrivals when it exists
      if (activeCategory !== NEW_ARRIVALS_ID) {
        setActiveCategory(NEW_ARRIVALS_ID);
      }
      return;
    }

    // ✅ No new arrivals → highlight first category
    if (!hasNewArrivals && firstCategoryId && activeCategory !== firstCategoryId) {
      setActiveCategory(firstCategoryId);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [newArrivals, categories]);

  useEffect(() => {
    return () => {
      dispatch(setSearchText(''));
    };
  }, [dispatch]);

  useEffect(() => {
    fetchUserData();
    // getNewArrivalsList();
  }, []);

  return (
    <>
      <Helmet>
        <title>Xpanse Cafe – Order Coffee Online from India’s First Tech-Driven Cafe</title>
        <meta name="description" content="Experience seamless ordering at Xpanse Cafe – a tech-first coffee brand. Order your favorite brews via our mobile app or website and skip the queue every time." />
        <meta property="og:title" content="Xpanse Cafe - Fuel UR Magic" />
        <meta property="og:description" content="Order your coffee smarter with Xpanse Cafe — India’s first tech-driven cafe experience. App-based ordering, cashless service, and no franchise fees until you profit." />
        <meta property="og:url" content="https://xpansecafe.com/" />
        <meta property="og:type" content="website" />
        <link rel="canonical" href="https://xpansecafe.com/" />
      </Helmet>
      <Hidden mdUp>
        <StoreHeader />
        <ArrivingNowOrders />
        {/* <SortByComponent activeFilter={activeFilter} onFilterChange={handleFilterChange} /> */}
      </Hidden>
      <Box>
        {fetchingProducts ? (
          <ProductListingSkeleton />
        ) : categories?.filter(category =>
          outletData?.isEventOutlet || !category?.isEventCategory
        ).every(category =>
          category.products.filter(product => outletData?.isEventOutlet || !product?.isEventProduct).filter(product => product?.status !== 'INACTIVE').length === 0
        ) ? (
          <Box sx={{ display: 'flex', flexDirection: 'column', textAlign: 'center' }}>
            <Player autoplay loop={true} keepLastFrame={true} src={Images.noResult} style={{ height: '350px' }} />
            <Typography variant='h6'>Sorry, didn't find what you are looking for...</Typography>
          </Box>
        ) : (
          <React.Fragment>
            <Box className="products-listing">
              <Box className="category-list">
                {/* {!!newArrivals?.length && (
                  <Box className="d-flex category-items-content" sx={{ position: 'relative' }}>
                    <Box className={`category-item-highlight-line ${activeCategory === NEW_ARRIVALS_ID ? 'active' : ''}`}></Box>
                    <Box
                      className={`category-item ${activeCategory === NEW_ARRIVALS_ID ? 'new-arrival active' : ''}`}
                      onClick={() => handleCategoryClick(NEW_ARRIVALS_ID)}
                    >
                      New Arrivals
                    </Box>
                  </Box>
                )} */}
                {/* {(newArrivals?.length ?? 0) > 0 && (
                  <Box className="d-flex category-items-content" sx={{ position: "relative" }}>
                    <Box className={`category-item-highlight-line ${activeCategory === NEW_ARRIVALS_ID ? "active" : ""}`} />
                    <Box
                      className={`category-item ${activeCategory === NEW_ARRIVALS_ID ? "new-arrival active" : ""}`}
                      onClick={() => handleCategoryClick(NEW_ARRIVALS_ID)}
                    >
                      New Arrivals
                    </Box>
                  </Box>
                )} 
                {(newArrivals?.length ?? 0) > 0 && (
                  <Box className="d-flex category-items-content" sx={{ position: "relative" }}>
                    <Box className={`category-item-highlight-line ${activeCategory === NEW_ARRIVALS_ID ? "active" : ""}`} />
                    <Box
                      className={`category-item ${activeCategory === NEW_ARRIVALS_ID ? "new-arrival active" : ""}`}
                      onClick={() => handleCategoryClick(NEW_ARRIVALS_ID)}
                    >
                      New Arrivals
                    </Box>
                  </Box>
                )}
                */}
                {categories?.slice().sort((a, b) => {
                  if (outletData.isEventOutlet) {
                    return (b.isEventCategory ? 1 : 0) - (a.isEventCategory ? 1 : 0) || a.sequenceNumber - b.sequenceNumber;
                  }
                  return a.sequenceNumber - b.sequenceNumber;
                }).filter(category => outletData.isEventOutlet || !category?.isEventCategory).map((category, index) => {
                  const hasNewProduct = category?.products?.some(product => product?.isNewProduct);
                  return (
                    <Box className="d-flex category-items-content" key={category._id} sx={{ position: 'relative' }}>
                      {/* <Box className={`category-item-highlight-line ${activeCategory === category._id || (index === 0 && !activeCategory) ? 'active' : ''}`}></Box> */}
                      <Box className={`category-item-highlight-line ${activeCategory === category._id ? 'active' : ''}`}></Box>
                      <Box
                        // className={`category-item ${activeCategory === category._id || (index === 0 && !activeCategory) ? 'active' : ''}`}
                        className={`category-item ${activeCategory === category._id ? 'active' : ''}`}
                        onClick={() => handleCategoryClick(category._id)}
                      >
                        {category?.name}
                        {/* {hasNewProduct && (
                          <img style={{ position: 'absolute', top: 10, right: 10 }} src={Images.newTag} />
                        )} */}
                      </Box>
                    </Box>)
                })}
              </Box>
              {/* <Box className="products-container">
                <Grid ref={containerRef} container>
                  {categories?.map((category, index) => {
                    let totalProductsRendered = 0;
                    const totalProducts = category?.products?.length;
                    let productsPerRow = 3;
                    return (
                      <>
                        <Box ref={setSectionRef(NEW_ARRIVALS_ID)} style={{ width: '100%' }}>
                          <Grid md={12}>
                            <img className="categoryTopImage" src={Images.newArrivalBanner} alt={'New Arrivals Banner'} />
                          </Grid>
                          {newArrivals?.slice().filter(product => product?.status !== 'INACTIVE')
                            .sort((a, b) => {
                              return a.sequenceNumber - b.sequenceNumber;
                            })
                            .map((product, productIndex) => {
                              const rowPosition = Math.floor(productIndex / productsPerRow);
                              const colPosition = productIndex % productsPerRow;
                              const isLastRow = (Math.ceil(totalProducts / productsPerRow) - 1) === rowPosition;
                              const isLastInRow = colPosition === (productsPerRow - 1) || productIndex === (totalProducts - 1);
                              const isFirstInRow = colPosition === 0;
                              return (
                                <>
                                  <Grid item sm={12} md={4} key={product?._id}>
                                    <ProductCard
                                      product={product?.product}
                                      // isFavorited={isProductInWishlist(product?._id)}
                                      quantityInCart={getProductQuantityInCart(product?._id)}
                                      handleProductClick={handleProductClick}
                                      matchesMdUp={matchesMdUp}
                                      isLastInRow={colPosition === productsPerRow - 1 || productIndex === totalProducts - 1}
                                      isLastRow={Math.ceil(totalProducts / productsPerRow) - 1 === rowPosition}
                                      // coupon={product?.bestCoupon}
                                      isFetchingBestCoupon={gettingBestCoupons}
                                      coupon={getBestCouponForProduct(product, category?._id)}
                                    />
                                  </Grid>
                                </>);
                            })}
                        </Box>
                        <Grid container key={category?._id}>
                          <Grid md={12}>
                            <img className="categoryTopImage" src={category?.bannerImageUrl} alt={category?.name} />
                          </Grid>
                          {category?.products.slice().filter(product => outletData?.isEventOutlet || !product?.isEventProduct).filter(product => product?.status !== 'INACTIVE')
                            .sort((a, b) => {
                              // Push exhausted products to the end
                              if (a.isExhausted && !b.isExhausted) return 1;
                              if (!a.isExhausted && b.isExhausted) return -1;
                              // Otherwise sort by sequence number
                              return a.sequenceNumber - b.sequenceNumber;
                            })
                            .map((product, productIndex) => {
                              const rowPosition = Math.floor(productIndex / productsPerRow);
                              const colPosition = productIndex % productsPerRow;
                              const isLastRow = (Math.ceil(totalProducts / productsPerRow) - 1) === rowPosition;
                              const isLastInRow = colPosition === (productsPerRow - 1) || productIndex === (totalProducts - 1);
                              const isFirstInRow = colPosition === 0;
                              return (
                                <>
                                  <Grid item sm={12} md={4} key={product?._id}>
                                    <ProductCard
                                      product={product}
                                      // isFavorited={isProductInWishlist(product?._id)}
                                      quantityInCart={getProductQuantityInCart(product?._id)}
                                      handleProductClick={handleProductClick}
                                      matchesMdUp={matchesMdUp}
                                      isLastInRow={colPosition === productsPerRow - 1 || productIndex === totalProducts - 1}
                                      isLastRow={Math.ceil(totalProducts / productsPerRow) - 1 === rowPosition}
                                      // coupon={product?.bestCoupon}
                                      isFetchingBestCoupon={gettingBestCoupons}
                                      coupon={getBestCouponForProduct(product, category?._id)}
                                    />
                                  </Grid>
                                </>);
                            })}
                        </Grid>
                      </>
                    )
                  })}
                </Grid>
              </Box> */}
              <Box className="products-container">
                <Grid ref={containerRef} container>

                  {/* ✅ New Arrivals - render ONLY ONCE */}
                  <Box ref={setSectionRef(NEW_ARRIVALS_ID)} style={{ width: '100%' }}>
                    {!!newArrivals?.length && (
                      <Grid item md={12} xs={12}>
                        <img
                          className="categoryTopImage"
                          src={Images.newArrivalBanner}
                          alt="New Arrivals Banner"
                        />
                      </Grid>
                    )}

                    <Grid container>
                      {newArrivals
                        ?.slice()
                        .filter(item => (item?.product?.status ?? item?.status) !== 'INACTIVE')
                        .sort((a, b) => a.sequenceNumber - b.sequenceNumber)
                        .map((item) => {
                          const p = item?.product;
                          const categoryId =
                            p?.category?._id ||
                            p?.categoryId ||
                            item?.categoryId ||
                            item?.category?._id ||
                            null;
                          return (
                            <Grid item sm={12} md={4} key={p?._id || item?._id}>
                              <ProductCard
                                product={p}
                                quantityInCart={getProductQuantityInCart(p?._id)}
                                handleProductClick={handleProductClick}
                                matchesMdUp={matchesMdUp}
                                isFetchingBestCoupon={gettingBestCoupons}
                                coupon={getBestCouponForProduct(p, categoryId)}
                              />
                            </Grid>
                          );
                        })}
                    </Grid>
                  </Box>

                  {/* ✅ Categories (each category has its own section ref) */}
                  {categories?.slice()
                    .sort((a, b) => {
                      if (outletData.isEventOutlet) {
                        return (b.isEventCategory ? 1 : 0) - (a.isEventCategory ? 1 : 0) || a.sequenceNumber - b.sequenceNumber;
                      }
                      return a.sequenceNumber - b.sequenceNumber;
                    })
                    .filter(category => outletData.isEventOutlet || !category?.isEventCategory)
                    .map((category) => (
                      <Box
                        key={category?._id}
                        ref={setSectionRef(category?._id)}
                        style={{ width: '100%' }}
                      >
                        <Grid item md={12} xs={12}>
                          <img
                            className="categoryTopImage"
                            src={category?.bannerImageUrl}
                            alt={category?.name}
                          />
                        </Grid>

                        <Grid container>
                          {category?.products
                            ?.slice()
                            .filter(product => outletData?.isEventOutlet || !product?.isEventProduct)
                            .filter(product => product?.status !== 'INACTIVE')
                            .sort((a, b) => {
                              if (a.isExhausted && !b.isExhausted) return 1;
                              if (!a.isExhausted && b.isExhausted) return -1;
                              return a.sequenceNumber - b.sequenceNumber;
                            })
                            .map((product) => (
                              <Grid item sm={12} md={4} key={product?._id}>
                                <ProductCard
                                  product={product}
                                  quantityInCart={getProductQuantityInCart(product?._id)}
                                  handleProductClick={handleProductClick}
                                  matchesMdUp={matchesMdUp}
                                  isFetchingBestCoupon={gettingBestCoupons}
                                  coupon={getBestCouponForProduct(product, category?._id)}
                                />
                              </Grid>
                            ))}
                        </Grid>
                      </Box>
                    ))}
                </Grid>
              </Box>
              <ProductDrawer
                open={!!selectedProduct}
                onClose={handleCloseModal}
                selectedProduct={selectedProduct}
                handleAddToCart={handleAddToCart}
                quantity={quantity}
                handleIncreaseQuantity={handleIncreaseQuantity}
                handleDecreaseQuantity={handleDecreaseQuantity}
                selectedAddons={selectedAddons}
                handleAddonSelect={handleAddonSelect}
                totalPrice={totalPrice}
                totalMrpPrice={totalMrpPrice}
                offerPercentage={offerPercentage}
                addingToCart={addingToCart}
                loadingProductDetails={fetchingProductDetails}
              />
              <Dialog open={loginModalOpen} onClose={() => setLoginModalOpen(false)}>
                <Box p={3}>
                  <Typography variant="h5">Login Required</Typography>
                  <Typography>Please login to use this feature.</Typography>
                  <Button onClick={() => setLoginModalOpen(false)}>Close</Button>
                  <Hidden mdUp>
                    <Button onClick={() => navigate('/mobileNumber')}>Login Now</Button>
                  </Hidden>
                </Box>
              </Dialog>
            </Box>

            {/* <Box className="product-listing-curve">
              <Box className="product-listing-curve-inside-box"></Box>
            </Box> */}
            <Box className="product-listing-line"></Box>
            <FloatingCart />
          </React.Fragment>
        )}
      </Box>
      <AuthModals openAuth={isModalOpen} handleCloseAuth={handleCloseAuth} />
      <BirthdayModal openBirthday={birthdayModal} handleCloseBirthday={handleCloseBirthday} />
      <Modal
        open={Boolean(popAdvertisement && randomAd)}
        onClose={() => setPopAdvertisement(false)}
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          border: 'none',
          outline: 'none',
          backgroundSize: 'cover',
          backgroundPosition: 'center',
        }}
      >
        <Box
          component="img"
          onClick={() => {
            handleAdvertismentProductClick(randomAd);
            setPopAdvertisement(false);
          }}
          src={randomAd?.advertisementImage}
          alt="Advertisement Image"
          sx={{
            width: {
              xs: '75%',
              sm: '65%',
              md: '25%',
            },
            border: 'none',
            outline: 'none',
            cursor: 'pointer'
          }}
        />
      </Modal>
    </>
  );
};

export default ProductsListing;